import { gql } from '@apollo/client';

export const CHECK_USER_EMAIL = gql`
	mutation CheckUserEmail($email: String!) {
		checkUserEmail(email: $email)
	}
`;

